"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ContentComponent {
    /**
     * Constructor
     */
    constructor() { }
}
exports.ContentComponent = ContentComponent;
